import React, { useRef } from 'react'
import { Trans, t } from '@lingui/macro'
import { useClipboard } from 'use-clipboard-copy'
import {
  Flex,
  Input,
  DrawerItem,
  DrawerItemHeader,
  DrawerItemHint,
  Box,
  ButtonIcon
} from 'front-end/src/components'

import { linkBuilder } from '../../../../../../shared/linkBuilder'
import { notification } from '../../../../components/common/notifications/Notifications'
import IconCopy from 'front-end/src/components/common/icon/IconCopy'

import './ResourceAccessLink.less'
import IconLink from '../../../../components/common/icon/IconLink'
import { brandColors } from '../../../../../../shared/basicPalette'
import { css } from '@emotion/react'

const ResourceAccessLink = ({ topicId }: { topicId: number }) => {
  const link = `${location.origin}${linkBuilder.topicUrl(topicId)}`
  const textAreaRef = useRef<HTMLInputElement>(null)
  const clipboard = useClipboard()

  return (
    <DrawerItem>
      <DrawerItemHeader dataTest="AccessLinkDrawer">
        <IconLink color={brandColors.grey['500']} />
        <Trans>Access link</Trans>
      </DrawerItemHeader>

      <Flex align="center">
        <Input
          variant="filled"
          ref={textAreaRef}
          value={link}
          readOnly
          css={css`
            vertical-align: middle;
            height: 40px;
            flex: 1;
            font-size: 12px;
            line-height: 15px;
          `}
        />
        <Box mx="8px">
          <ButtonIcon
            hint={t`Copy to clipboard`}
            aria-label={t`Copy to clipboard`}
            onClick={() => {
              clipboard.copy(link)
              notification.info(t`Successfully copied to clipboard`)
            }}
            icon={<IconCopy boxSize="16px" />}
            data-test="CopyButton"
          />
        </Box>
      </Flex>

      <DrawerItemHint>
        <Trans>Access available to current workspace members</Trans>
      </DrawerItemHint>
    </DrawerItem>
  )
}

export default ResourceAccessLink
